module.exports = __webpack_public_path__ + "static/media/avatar.e401555a.svg";